import { Component } from "solid-js";

const NotFound: Component = () => {
  return (
    <>
      <h1 class="text-xl">Not Found</h1>
      <p>...</p>
    </>
  );
};

export default NotFound;
